import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const UnderConstructionBanner = () => {
  const [enabled, setEnabled] = useState(false);
  const [text, setText] = useState('');

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/site-settings`)
      .then((res) => {
        if (cancelled) return;
        setEnabled(Boolean(res.data?.under_construction_banner));
        setText(res.data?.banner_text || '');
      })
      .catch(() => {
        // Fail closed: no banner if settings can't load
      });
    return () => { cancelled = true; };
  }, []);

  if (!enabled) return null;

  return (
    <div
      className="bg-terracotta/15 border-b border-maroon/10 text-maroon py-2 px-4 text-center"
      data-testid="construction-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center space-x-2">
        <AlertCircle size={18} className="flex-shrink-0" />
        <p className="text-sm font-semibold">{text}</p>
      </div>
    </div>
  );
};

export default UnderConstructionBanner;
